export default __webpack_public_path__ + "static/inkspillV-s-3e02e383b4b39e4dfecba59f2ec62702.mp4";